module.exports = __webpack_public_path__ + "img/information-icon-white.fd641d76.svg";